import { useEffect, useState } from 'react'

import { ClientSignUpAnalytics } from 'components/client-sign-up/analytics'
import s from './styles.module.css'
import { Button } from 'components/design-system/button'
import Router from 'next/router'

interface ReengagementFormProps {
  onRetry: (data?: any) => void
  onCancelReengagement: () => void
  onReengagementLinkClick: () => void
  reengagementLink?: string
  signInTokenMutation: any
  isActiveClientNonInsurance?: boolean
  isActiveClient?: boolean
  isReferredByCoach?: string
}

const ReengagementForm = ({
  onRetry,
  onCancelReengagement,
  onReengagementLinkClick,
  reengagementLink,
  signInTokenMutation,
  isActiveClientNonInsurance,
  isActiveClient,
  isReferredByCoach,
}: ReengagementFormProps) => {
  const [hasRetried, setHasRetried] = useState(false)
  const [token, setToken] = useState('')
  const [authTokenError, setAuthTokenError] = useState('')

  const handleSubmit = async () => {
    const {
      data: {
        signInToken: { sessionToken },
      },
    } = await signInTokenMutation({ variables: { token } })

    if (!sessionToken) {
      setAuthTokenError('The token you entered is expired or invalid')
      return
    }
    Router.push(reengagementLink)
    onReengagementLinkClick()
  }

  const handleRetry = () => {
    if (hasRetried) return

    ClientSignUpAnalytics.onResendReengagementText()
    onRetry(!!reengagementLink)
    setHasRetried(true)
  }

  const handleCancelReengagement = () => {
    ClientSignUpAnalytics.onCancelReengagement()
    onCancelReengagement()
  }

  useEffect(() => {
    if (hasRetried) {
      setTimeout(() => {
        setHasRetried(false)
      }, 3000)
    }
  }, [hasRetried])

  const reengagementText = () => {
    if (isActiveClientNonInsurance) {
      return (
        <span>
          Please reach out to support chat or{' '}
          <a href="mailto:hello@trainwithkickoff.com">
            hello@trainwithkickoff.com
          </a>{' '}
          if you are interested in insurance-covered training.
        </span>
      )
    }

    if (isActiveClient) {
      return (
        <span>
          You are already an active client. Please reach out to support chat or{' '}
          <a href="mailto:hello@trainwithkickoff.com">
            hello@trainwithkickoff.com
          </a>{' '}
          if you have any questions.
        </span>
      )
    }
    if (isReferredByCoach) {
      return 'For security purposes, please click the link in the text message we just sent you to continue your sign up.'
    }

    return 'For security purposes, please click the link in the text message we just sent you to select your coach.'
  }

  return (
    <div>
      <h2 className={s.reengagementHeader}>Welcome Back to Kickoff!</h2>
      <div className={s.reengagementBody}>
        <p className={s.reengagementText}>{reengagementText()}</p>
        {!hasRetried && !isActiveClientNonInsurance && !isActiveClient && (
          <div className={s.buttons}>
            <Button
              className={s.retryButtonB}
              variant="text"
              size="small"
              onClick={handleRetry}>
              Resend text
            </Button>
          </div>
        )}
        {hasRetried && <span className={s.retryConfirmation}>Sent!</span>}
        {onCancelReengagement && (
          <button
            className={s.cancelReengagementButton}
            onClick={handleCancelReengagement}>
            I entered my phone number incorrectly
          </button>
        )}
      </div>
    </div>
  )
}

export default ReengagementForm
